import { CloseCircleOutlined, ReloadOutlined } from "@ant-design/icons";
import {
    Button,
    Col,
    Form,
    Image,
    Input,
    Row,
    Select,
    Tabs,
    DatePicker,
    Checkbox,
} from "antd";
import { useState } from "react";
import MainLayout from "./../../../components/mainLayout";
import "./index.scss";
import Upload from "./../../../commons/Upload";
import NewsForm from "./../../../components/form/newsForm";
import { authApis } from "./../../../services/authApi";
import { nofication } from "./../../../commons/Nofication";
import { useParams } from "react-router-dom";
import { ROOT_URL } from "../../../constants/api";
import moment from "moment";
import BackButton from "../../../commons/BackButton";

const { TabPane } = Tabs;
const style = { padding: "8px 20px" };

const Register = ({ history, match }) => {
    const [fileList, setFileList] = useState();
    const [imageUrl, setImageUrl] = useState();
    const [fileBannerList, setFileBannerList] = useState();
    const [imageBannerUrl, setImageBannerUrl] = useState();
    const [content, setContent] = useState({
        content_vi: "",
        content_en: "",
        content_kr: "",
    });
    const [form] = Form.useForm();
    const { id } = useParams();
    const [subcategories, setSubcategories] = useState([]);
    const [isCheckRemoveImg, setIsCheckRemoveImg] = useState(false);
    const [isCheckRemoveBannerImg, setIsCheckRemoveBannerImg] = useState(false);
    const [ischecked, setIshecked] = useState(false);
    const [ischeckedTop, setIsheckedTop] = useState(false);
    const [initData, setInitData] = useState();
    const [isCheck, setisCheck] = useState(id);
    const onChange = (e) => {
        console.log(e.target);
        if (e.target && e.target.checked !== "") {
            form.setFieldsValue({ is_feature: e.target.checked });
            setIshecked(e.target.checked);
        }
    };

    const onChangeTop = (e) => {
        console.log(e.target);
        if (e.target && e.target.checked !== "") {
            form.setFieldsValue({ is_top_news: e.target.checked });
            setIsheckedTop(e.target.checked);
        }
    };

    useState(() => {
        if (id > 0) {
            authApis
                .getDetailNews(id)
                .then((data) => {
                    if (data.status_code === 200) {
                        let values = data?.news;
                        setContent({
                            content_vi: data.news?.content_vi ?? '<p></p>',
                            content_en: data.news?.content_en ?? '<p></p>',
                            content_kr: data.news?.content_kr ?? '<p></p>',
                        });
                        setSubcategories(data?.subcategories ?? []);
                        if (data.news?.created_at) {
                            const dataNew = moment(data.news?.created_at);
                            values.created_at = dataNew;
                        }
                        setIshecked(data.news?.is_feature == 1 ? true : false);
                        setIsheckedTop(data.news?.is_top_news == 1 ? true : false);
                        form.setFieldsValue(values);
                        setImageUrl(
                            data.news.image ? ROOT_URL + data.news.image : ""
                        );
                        setImageBannerUrl(
                            data.news.image_banner ? ROOT_URL + data.news.image_banner : ""
                        );
                    } else {
                        nofication(
                            "error",
                            "Thất bại",
                            "Vui lòng kiểm tra lại thông tin !"
                        );
                    }
                })
                .catch((errors) => {
                    nofication(
                        "error",
                        "Thất bại",
                        "Không kết nối được server"
                    );
                    console.log(errors);
                });
        } else {
            authApis
                .getCategory()
                .then((data) => {
                    setSubcategories(data?.subcates ?? []);
                    form.resetFields();
                    setContent({
                        content_vi: '',
                        content_en: '',
                        content_kr: '',
                    });
                    setIshecked(false);
                    setImageUrl('');
                })
                .catch((errors) => {
                    nofication(
                        "error",
                        "Thất bại",
                        "Không kết nối được server"
                    );
                    console.log(errors);
                });
        }
    }, [isCheck]);

    const onChangeContentValue = (e) => {
        const name = e.name;
        const contentNew = e.content;
        setContent({ ...content, [name]: contentNew });
    };

    const onFinish = async () => {
        const values = form.getFieldValue();
        values.logo = undefined;
        const formData = new FormData();
        for (var key in values) {
            formData.append(key, values[key]);
        }
        if (id) {
            formData.append("id", id);
        }
        formData.append("logo", fileList);
        formData.append("image_banner", fileBannerList);
        formData.append("isCheckRemoveImg", isCheckRemoveImg);
        formData.append("isCheckRemoveBannerImg", isCheckRemoveBannerImg);
        formData.append(
            "content_vi",
            content.content_vi ? content.content_vi : values.content_vi
        );
        formData.append(
            "content_en",
            content.content_en ? content.content_en : values.content_en
        );
        formData.append(
            "content_kr",
            content.content_kr ? content.content_kr : values.content_kr
        );
        await authApis
            .news(formData)
            .then((data) => {
                if (data.status_code === 200) {
                    nofication("success", "Thành công", "Cập nhật thành công!");
                } else {
                    nofication(
                        "error",
                        "Thất bại",
                        "Vui lòng kiểm tra lại thông tin !"
                    );
                }
            })
            .catch((errors) => {
                nofication("error", "Thất bại", "Không kết nối được server");
                console.log(errors);
            });
    };

    return (
        <MainLayout isShowActionHeader={false} title="News" link="/news/" titleNew="News / Edit">
            <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                colon={true}
            >
                <Row gutter={16}>
                    <Col span={19} xs={24} sm={24} md={24} lg={19} xl={19} xxl={19}>
                        <div className="box-class">
                            <Tabs defaultActiveKey="1" onChange={onChange}>
                                <TabPane tab="Tiếng việt" key="1">
                                    <NewsForm
                                        lang={"vi"}
                                        onChangeContentValue={
                                            onChangeContentValue
                                        }
                                        content={content}
                                        id={id}
                                    />
                                </TabPane>
                                <TabPane tab="Tiếng anh" key="2">
                                    <NewsForm
                                        lang={"en"}
                                        onChangeContentValue={
                                            onChangeContentValue
                                        }
                                        content={content}
                                        id={id}
                                    />
                                </TabPane>
                                <TabPane tab="Tiếng hàn" key="3">
                                    <NewsForm
                                        lang={"kr"}
                                        onChangeContentValue={
                                            onChangeContentValue
                                        }
                                        content={content}
                                        id={id}
                                    />
                                </TabPane>
                            </Tabs>
                            <Form.Item>
                                <Row
                                    justify="space-between"
                                    style={{ marginTop: 30 }}
                                >
                                    <Col>
                                        <Button
                                            type="primary"
                                            icon={<ReloadOutlined />}
                                            htmlType="submit"
                                        >
                                            Submit
                                        </Button>
                                        <Button
                                            htmlType="reset"
                                            style={{
                                                background: "#6c757d",
                                                color: "white",
                                                marginLeft: 20,
                                            }}
                                        >
                                            Reset
                                        </Button>
                                    </Col>
                                    <Col>
                                        <BackButton/>
                                    </Col>
                                </Row>
                            </Form.Item>
                        </div>
                    </Col>
                    <Col span={5} style={{ paddingRight: '20px' }} xs={24} sm={24} md={24} lg={5} xl={5} xxl={5} className='bost'>
                        <Col span={24} className="box-class" style={style}>
                            <Form.Item
                                label="Category"
                                colon={true}
                                name={"id_subcategory"}
                            >
                                {subcategories.length ? (
                                    <Select
                                        Select
                                        placeholder={"Select Category"}
                                    >
                                        {subcategories?.map((item) => {
                                            return (
                                                <Select.Option
                                                    value={item.id}
                                                    key={item.id}
                                                >
                                                    {item.title_vi}
                                                </Select.Option>
                                            );
                                        })}
                                    </Select>
                                ) : (
                                    <></>
                                )}
                            </Form.Item>
                            <Form.Item
                                label="Post Status"
                                name={"status"}
                                colon={true}
                            >
                                <Select placeholder={"Select publish"}>
                                    <Select.Option value={0}>
                                        Unpublished
                                    </Select.Option>
                                    <Select.Option value={1}>
                                        Publish
                                    </Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Created at"
                                colon={true}
                                name={"created_at"}
                            >
                                <DatePicker
                                    name={"created_at"}
                                    showTime
                                    style={{ width: "100%" }}
                                />
                            </Form.Item>
                            <Form.Item label="Thumnail" colon={true}>
                                <Upload
                                    imageUrl={imageUrl}
                                    setFileList={setFileList}
                                    setImageUrl={setImageUrl}
                                    span={24}
                                    setIsCheckRemoveImg={setIsCheckRemoveImg}
                                />
                            </Form.Item>
                            <Form.Item colon={true} name={"is_feature"}>
                                <Checkbox
                                    onChange={onChange}
                                    checked={ischecked}
                                >
                                    Is feature?
                                </Checkbox>
                            </Form.Item>
                            <Form.Item label="Banner" colon={true}>
                                <Upload
                                    imageUrl={imageBannerUrl}
                                    setFileList={setFileBannerList}
                                    setImageUrl={setImageBannerUrl}
                                    span={24}
                                    setIsCheckRemoveImg={setIsCheckRemoveBannerImg}
                                />
                            </Form.Item>
                            <Form.Item colon={true} name={"is_top_news"}>
                                <Checkbox
                                    onChange={onChangeTop}
                                    checked={ischeckedTop}
                                >
                                    Is Top News?
                                </Checkbox>
                            </Form.Item>

                        </Col>
                    </Col>
                </Row>
            </Form>
        </MainLayout>
    );
};

export default Register;
